let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8iznl")).then(() => parcelRequire('9T85m'));